export default __webpack_public_path__ + "static/media/background-image.722b5d9e.png";